export const Minus = () => (
  <svg
    width="15"
    height="5"
    viewBox="0 0 15 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0469 4.97851C11.6808 4.95756 12.2941 4.81598 12.8506 4.56213C13.4071 4.30829 13.8956 3.94731 14.2872 3.5005C14.4847 3.32187 14.6202 3.08981 14.6778 2.83128C14.7355 2.57276 14.7129 2.29839 14.6128 2.04005C14.5127 1.78171 14.3392 1.55002 14.1124 1.3719C13.8855 1.19378 13.6147 1.07654 13.3315 1.03382C12.1559 0.804469 10.9657 0.716317 9.78959 0.771497C7.56597 0.848183 5.36443 1.0448 3.15407 1.25862C2.48865 1.34019 1.84609 1.51182 1.24559 1.76838C0.88537 1.9182 0.574467 2.14967 0.338379 2.44381C-0.234854 3.23612 0.10744 3.96551 1.10557 4.18387C1.85638 4.31351 2.61169 4.39587 3.36643 4.4304L9.87927 4.85791L11.0469 4.97851Z"
      fill="#EF4135"
    />
  </svg>
);
